module.exports = __WEBPACK_EXTERNAL_MODULE_102__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/Shape","root":["openfl","display","Shape"],"commonjs":"openfl/display/Shape","commonjs2":"openfl/display/Shape"}
// module id = 102
// module chunks = 0